import { render, staticRenderFns } from "./LeaveForm.vue?vue&type=template&id=de1c6690&scoped=true"
import script from "./LeaveForm.vue?vue&type=script&lang=js"
export * from "./LeaveForm.vue?vue&type=script&lang=js"
import style0 from "./LeaveForm.vue?vue&type=style&index=0&id=de1c6690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1c6690",
  null
  
)

export default component.exports